import React from "react";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import  CardTool from "../../component/shared/cardTool/CardTool.js";
import { useIntl } from "react-intl";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import { END_POINTS } from "constants/APIConstant";
import AOS from 'aos';
import 'aos/dist/aos.css'
import useSWR from "swr";
import DataNotFound from "component/shared/DataNotFound/DataNotFound.jsx";
import ReactGA from "react-ga4";

function ServicesTools() {

  const intl = useIntl();

  React.useEffect(() => {   
    AOS.init();
    AOS.refresh();
}, [])

  const servicesTools = useSWR({
    url: END_POINTS.SERVICES_TOOLS,
  });

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut)
    }
  }, [])


  ReactGA.initialize(END_POINTS.TRACKING_ID)

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/servicestools", title: "ServicesTools Page" });
  }, []);


  const RenderServicesTools = () => {
    const servicesToolsData =
      servicesTools.error ||
      servicesTools.isLoading ||
      servicesTools.data === undefined ||
      servicesTools.data.data === undefined
        ? []
        : servicesTools.data.data;

    const rendering = servicesToolsData.map(
      ({ id, content, title, image, shortDescription, link, serviceAndToolTranslation, isInternal, isSystem }, i) => {
        return  (
          <CardTool
            key={i} 
            title={title} 
            image={image} 
            desc={shortDescription} 
            link={link} 
            serviceAndToolTranslation={serviceAndToolTranslation} 
            isInternal={isInternal} 
            isSystem={isSystem} 
            id={id} 
          />
        );
      }
    );
    return rendering;
  };


  return (
    <ContentLoading isLoading={servicesTools.isLoading}>
      <div className="ServicesTools">
        <InnerHeader
          breadcrumb={[{title: intl.formatMessage({ id: "service-tools"}) , clickClass:true}]}
          title= {intl.formatMessage({ id: "service-tools-title" })}
        />
        <div className="container ServicesTools-body py-4" data-aos='fade-down' data-aos-duration="1000" data-aos-easing="ease-in-sine">
          <div className="row gx-xl-5 gx-lg-4 gx-md-3 gx-0">
            {Object.keys(<RenderServicesTools />).length > 0 ? (
                <RenderServicesTools />
              ) : (
                <DataNotFound />
              )
            }
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default ServicesTools;
